// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1KEmt","row":"Node_row__1yc-g","label":"Node_label__3UtnJ","footer":"Node_footer__3IZ-s"};